var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "250px" } },
    [
      _c(
        "v-simple-table",
        { staticStyle: { background: "none" }, attrs: { dense: "" } },
        [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "text-left" }, [_vm._v("Názov")]),
              _c("th", { staticClass: "text-left" }, [_vm._v("Verzia")])
            ])
          ]),
          _c(
            "tbody",
            [
              _c("tr", [
                _c("td", [_vm._v("Filip.Client")]),
                _c("td", [_vm._v(_vm._s(_vm.client))])
              ]),
              _vm._l(_vm.api, function(item, index) {
                return _c("tr", { key: index }, [
                  _c("td", [_vm._v(_vm._s(item.assemblyName))]),
                  _c("td", [_vm._v(_vm._s(item.version))])
                ])
              })
            ],
            2
          )
        ]
      ),
      _vm.errorMessages.length > 0
        ? _c("p", { staticClass: "mt-2" }, [_vm._v(_vm._s(_vm.errorMessages))])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }